import type { FindingCategory, ScanFinding } from '@/lib/apiTypes'
import { SEVERITY_COLOR } from '@/lib/format'
import { ScanFindingRow } from '@/features/modules/components/ScanFindingRow'
import { SEVERITIES } from '@/features/modules/lib/severities'
import { findingInCategory } from '@/features/modules/tabs/moduleTabs'

// ── Category findings tab ─────────────────────────────────────────────────────
export function CategoryFindingsTab({ category, findings, scanning }: { category: FindingCategory; findings: ScanFinding[]; scanning: boolean }) {
  const categoryFindings = findings.filter((f) => findingInCategory(f, category))

  if (scanning) {
    return (
      <div style={{ color: 'var(--text3)', fontFamily: 'var(--mono)', fontSize: '0.8rem' }}>
        <span className="spinner" style={{ width: 10, height: 10, marginRight: 8 }} />
        Scan Pending - findings will appear here once complete.
      </div>
    )
  }

  if (!categoryFindings.length) {
    return (
      <div style={{ fontFamily: 'var(--mono)', fontSize: '0.8rem', color: 'var(--text3)' }}>
        // no findings
      </div>
    )
  }

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      {SEVERITIES.map((sev) => {
        const hits = categoryFindings.filter((f) => f.severity === sev)
        if (!hits.length) return null
        return (
          <div key={sev}>
            <div style={{
              fontFamily: 'var(--mono)', fontSize: '0.72rem',
              color: SEVERITY_COLOR[sev], marginBottom: 6,
              paddingLeft: 8, borderLeft: `2px solid ${SEVERITY_COLOR[sev]}`,
            }}>
              {sev.toUpperCase()} ({hits.length})
            </div>
            <div className="stack-4">
              {hits.map((f) => <ScanFindingRow key={f.id} finding={f} />)}
            </div>
          </div>
        )
      })}
    </div>
  )
}
